export default __webpack_public_path__ + "static/media/newsExplorer.cbac983a.JPG";